// دوال تنسيق مشتركة لصفحة تفاصيل أمر الشراء.
export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const pad = (n) => String(n).padStart(2, "0");
  let h = d.getHours();
  const m = pad(d.getMinutes());
  const suffix = h >= 12 ? "pm" : "am";
  h = h % 12 || 12;
  return `${fmtDate(iso)} ${pad(h)}:${m} ${suffix}`;
};

export const stateTone = (state) => {
  if (["approved", "sent", "confirmed", "received", "matched", "posted",
       "paid", "closed"].includes(state))
    return "bg-emerald-100 text-emerald-700 border-emerald-200";
  if (["submitted", "pending_approval", "partially_received", "partially_paid"].includes(state))
    return "bg-amber-100 text-amber-700 border-amber-200";
  if (["rejected", "supplier_rejected", "cancelled", "disputed", "returned"].includes(state))
    return "bg-rose-100 text-rose-700 border-rose-200";
  return "bg-slate-100 text-slate-700 border-slate-200";
};
